import { render, staticRenderFns } from "./UserDialogCommentTabComponent.vue?vue&type=template&id=e771b6b6&scoped=true"
import script from "./UserDialogCommentTabComponent.js?vue&type=script&lang=js&external"
export * from "./UserDialogCommentTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserDialogCommentTabComponent.vue?vue&type=style&index=0&id=e771b6b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e771b6b6",
  null
  
)

export default component.exports